module.exports = __webpack_public_path__ + "img/beer_id-81.0a5c7636.png";